'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import Button, { ButtonSize } from '@/src/app/components/Button/Button.tsx';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
import { usePathname, useRouter } from 'next/navigation';
import { LayoutTemplateContext } from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/LayoutTemplateProvider.tsx';
import { CatalogRequestParams } from '@/src/lib/category/types.ts';
import { IconName } from '@/src/app/components/Icon/types.ts';
export type ResetFiltersButtonProps = {
  dict: Dictionary;
  chips: Array<{
    params: Array<{
      name: string;
      value: string;
    }>;
    label: string;
  }>;
};
export default function ResetFiltersButton(t0) {
  const $ = _c(9);
  const {
    chips,
    dict
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const {
    startTransition,
    isPending
  } = useContext(LayoutTemplateContext);
  let t1;
  if ($[0] !== chips || $[1] !== pathname || $[2] !== router || $[3] !== startTransition) {
    t1 = function handleOnClick() {
      startTransition(() => {
        const searchParams = new URLSearchParams(window.location.search);
        chips.forEach(chip => {
          chip.params.forEach(param => searchParams?.delete(param.name));
        });
        searchParams.set(CatalogRequestParams.PAGE, "1");
        router.push(decodeURI(`${pathname}?${searchParams.toString()}`));
      });
    };
    $[0] = chips;
    $[1] = pathname;
    $[2] = router;
    $[3] = startTransition;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleOnClick = t1;
  let t2;
  if ($[5] !== dict.category.filters.reset || $[6] !== handleOnClick || $[7] !== isPending) {
    t2 = <Button priority={true} className="bg-gray-500!" size={ButtonSize.SMALL} onClick={handleOnClick} icon={IconName.DELETE} disabled={isPending} data-testid="filter-reset-button">{dict.category.filters.reset}</Button>;
    $[5] = dict.category.filters.reset;
    $[6] = handleOnClick;
    $[7] = isPending;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}